<template>
    <div class="form-group lm-super-power-select-v2" v-if="isVisible" :class="{ row : isOnModeLabelOnLeft }">
      <label
        v-if="label"
        :title="titleComputed"
        :for="idComputed"
        :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
        class="text-truncate"
        >{{label}} <small v-if="required">*</small></label>
        <font-awesome-icon
          id="font-awesome-icon-edit"
          icon="edit"
          size="sm"
          class="clickable float-right mt-1"
          v-if="showEditButton"
          @click="$emit('edit-button-clicked')"
          />
        <div
          :class="{ 'col-sm-10': isOnModeLabelOnLeft }"
          @keyup.enter="enter"
          >
          <v-selectpage
            tabindex="0"
            class="text-truncate"
            ref="vSelectpage"
            :key-field="keyField"
            :disabled="disabled || isLoading"
            :class="{'selectpage-error': v.$error}"
            :data="optionsData"
            :pageSize="pageSize"
            :multiple="multiple"
            :language="language"
            :title="title"
            :tb-columns="tbColumns"
            :placeholder="isLoading ? 'Loading...' : placeholder"
            v-model="optionSelected"
            @values="valuesHandler($event)"
            />
          <p class="invalid-feedback d-block" v-if="!v.required && v.$error"> {{ $t('field_required')}} </p>
        </div>
    </div>
</template>

<script>
import { SelectPage } from 'v-selectpage'
import lmInputMixin from '@/mixins/lmInputMixin.js'
import commonsApi from '@/api/commons'

export default {
  data () {
    return {
      optionSelected: null,
      optionsData: [],
      isLoading: false
    }
  },
  mixins: [lmInputMixin],
  components: {
    'v-selectpage': SelectPage
  },
  props: {
    defaultValue: {
      type: [Object, Array, String],
      default: () => ({})
    },
    keyField: {
      type: String,
      default: 'id'
    },
    tbColumns: {
      type: Array,
      default: () => []
    },
    language: {
      type: String,
      default: 'es'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 10
    },
    options: {
      type: [String, Array],
      default: ''
    },
    urlPathFromGetOptions: {
      type: String,
      default: ''
    }
  },
  methods: {
    valuesHandler (event) {
      let optionsSelected = this.multiple ? event : event[0]
      this.$emit('input', optionsSelected)
    },
    enter () {
      this.$refs.vSelectpage.$refs.drop.visible()
      this.$on('values', function () {
        setTimeout(() => {
          this.$refs.vSelectpage.$el.focus()
        }, 1000)
      })
    },
    remove () {
      this.$refs.vSelectpage.remove()
    },
    hide () {
      setTimeout(() => {
        console.log('this.$refs.vSelectpage.$refs.drop.show', this.$refs.vSelectpage.$refs.drop.show)
        if (this.$refs.vSelectpage.$refs.drop.show) {
          this.$refs.vSelectpage.$refs.drop.visible()
        }
      }, 10)
    },
    initialOptionSelected (value = this.value) {
      if (Array.isArray(value)) {
        this.optionSelected = value.map(option => option.id).join(',')
      }
      if (value !== null && value !== undefined && value.constructor.name === 'Object') {
        this.optionSelected = value?.id?.toString()
      }
      if (typeof value === 'string') {
        const option = this.options.find(e => e.name === value)
        this.optionSelected = option?.id?.toString()
      }
    },
    async getOptionsFromPath (url = this.urlPathFromGetOptions) {
      this.isLoading = true
      const optionsFromPath = await commonsApi.axiosGetWrapper(url)
      this.isLoading = false
      return optionsFromPath.data.items
    },
    async setOptions () {
      if (this.urlPathFromGetOptions) {
        this.optionsData = await this.getOptionsFromPath()
      } else {
        this.optionsData = this.options
      }
    }
  },
  watch: {
    urlPathFromGetOptions () {
      this.setOptions()
    },
    options () {
      this.optionsData = this.options
    },
    defaultValue () {
      this.initialOptionSelected(this.defaultValue)
    }
  },
  async created () {
    await this.setOptions()
    this.initialOptionSelected()
  }
}
</script>

<style lang="sass">
.selectpage-error
  .sp-input-container
    .sp-inputs,
    .sp-input
      border: 1px solid red !important
.sp-base
  min-height: 38px !important
.sp-input
  span
    display: block !important
    overflow: hidden
    padding-right: 35px !important
    text-overflow: ellipsis
</style>
